import { Navigate } from "react-router-dom";

export const TraineeGuard = ({ children } :{children: any}) => {
    const authed = true // isauth() returns true or false based on localStorage
    
    return authed ? children : <Navigate to="/" />;
  }